// shared production constants.
/**
 * A vessel is "in production" while it has >= 2 labour-hours remaining; below that
 * it counts as "complete". board tiles key off this SAME metric so they sum exactly
 * (see worker.js:257-259 — the 2026-07-22 fix that stopped ~99.6%-done vessels being
 * counted as both in-production and complete).
 */
export const INPROD_THRESHOLD_HOURS = 2;
/** default team headcounts (overridable via D1 app-config). */
export const DEFAULT_REPORT_MEMBERS = { GGO: 18, ALPHAS: 16, XPD: 6 };
//# sourceMappingURL=constants.js.map